import 'core-js/stable';
import 'regenerator-runtime/runtime';
import cssVars from 'css-vars-ponyfill';

/**
 * Polyfill css variables.
 */
cssVars();
